<template>
  <ModalStructure @close="$emit('close')">
    <div slot="title">Stripe Payment Configuration</div>
    <div slot="body">
      <v-alert
        type="warning"
        border="left"
        text
        v-if="!selectedProject.stripeApiKey"
      >
        You need to assign a
        <u>Stripe Api Key</u> to your project. Go to
        <strong>Settings</strong>
        >
        <strong>Integrations</strong> page and add there. Follow the steps
        documented
        <a
          href="https://help.landly.page/how-can-i-accept-stripe-payment"
          target="_blank"
          >here</a
        >.
      </v-alert>
      <v-alert
        type="warning"
        border="left"
        text
        v-if="selectedProject.stripeApiKey"
      >
        You can follow the steps documented
        <a
          href="https://help.landly.page/how-can-i-accept-stripe-payment"
          target="_blank"
          >here</a
        >.
      </v-alert>
      <v-alert type="info" border="left" text
        >Your data is cached for 1 minute. If you can't see your Stripe data,
        please wait for 1-2 minutes.</v-alert
      >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg"
        style="width: 90px; height: 37px"
      />
      <div>
        Configuring Stripe for
        <strong>
          <i>{{ link.text }}</i>
        </strong>
        link. Select a product to buy when the link
        <strong>
          <i>{{ link.text }}</i>
        </strong>
        is clicked:
      </div>
      <v-text-field
        v-model="link.stripeConfig.planId"
        outlined
        dense
        label="Plan or Price Id"
        :placeholder="'Plan or Price Id'"
        autocomplete="off"
        class="mt-3"
        @input="saveBlockDebounced(block)"
        :error="link.stripeConfig.planId == ''"
        :disabled="!selectedProject.stripeApiKey"
      ></v-text-field>
      <v-select
        label="Mode"
        :items="[
          { id: 'payment', name: 'Payment' },
          { id: 'subscription', name: 'Subscription' },
        ]"
        v-model="link.stripeConfig.mode"
        dense
        outlined
        item-value="id"
        item-text="name"
        style="width: 300px"
        class="mt-3 mb-3"
        @change="saveBlockDebounced(block)"
        :error="link.stripeConfig.mode == ''"
        :disabled="!selectedProject.stripeApiKey"
      ></v-select>
      <v-divider></v-divider>
      <div class="mt-3">
        Define the success and cancel redirect page URLs. Don't forget to create
        them or your customers will get 404 error after purchasing.
      </div>
      <v-text-field
        v-model="link.stripeConfig.successUrl"
        outlined
        dense
        label="Payment Success Redirect Url"
        :placeholder="
          'Example https://' +
          selectedProject.computedDomain +
          '/payment/success'
        "
        autocomplete="off"
        class="mt-3"
        @input="saveBlockDebounced(block)"
        :error="link.stripeConfig.successUrl == ''"
        :disabled="!selectedProject.stripeApiKey"
      ></v-text-field>
      <v-text-field
        v-model="link.stripeConfig.cancelUrl"
        outlined
        dense
        label="Payment Cancel Redirect Url"
        :placeholder="
          'Example https://' +
          selectedProject.computedDomain +
          '/payment/cancel'
        "
        autocomplete="off"
        class="mt-3"
        @input="saveBlockDebounced(block)"
        :error="link.stripeConfig.cancelUrl == ''"
        :disabled="!selectedProject.stripeApiKey"
      ></v-text-field>
      <v-alert type="info" border="left" text class="mt-2">
        Test your Stripe integration after publishing your website. Your website
        url is:
        <a :href="'https://' + selectedProject.computedDomain">{{
          selectedProject.computedDomain
        }}</a>
      </v-alert>
    </div>
  </ModalStructure>
</template>

<script>
import projectMixin from "../project-mixin";

export default {
  mixins: [projectMixin],
  props: ["block", "link"],
};
</script>